import { useRef, useState } from 'react';
import useDidMount from './useDidMount';
import CKEditor from 'src/components/common/ReactCKEditor';

export default function useRenderEditor<T extends HTMLElement>(onCKEditorDialogDefintion = true) {
  const container = useRef<T>();
  const [rendered, setRendered] = useState<boolean>(false);

  useDidMount(() => {
    if (onCKEditorDialogDefintion === true) CKEditor.onCKEditorDialogDefintion();
    setRendered(true);
  });

  return { container, rendered };
}
